import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { fetchLeaderboard } from "../../lib/api.js";

const WINDOWS = ["24h", "7d", "30d", "all"] as const;

export function Leaderboard() {
  const [window, setWindow] = useState<(typeof WINDOWS)[number]>("30d");
  const q = useQuery({
    queryKey: ["leaderboard", window],
    queryFn: () => fetchLeaderboard(window),
    refetchInterval: 60_000,
  });

  const rows = q.data ?? [];
  return (
    <div className="flex h-full flex-col bg-zinc-950">
      <header className="flex items-center justify-between border-b border-zinc-800 px-4 py-2">
        <span className="text-xs uppercase tracking-wider text-zinc-400">
          Strategy leaderboard
        </span>
        <div className="flex overflow-hidden rounded ring-1 ring-zinc-800 text-xs">
          {WINDOWS.map((w) => (
            <button
              key={w}
              type="button"
              onClick={() => setWindow(w)}
              className={
                "px-2 py-1 font-mono " +
                (w === window
                  ? "bg-accent text-zinc-950"
                  : "bg-zinc-900 text-zinc-400 hover:text-zinc-100")
              }
            >
              {w}
            </button>
          ))}
        </div>
      </header>
      <div className="flex-1 overflow-auto">
        {rows.length === 0 ? (
          <div className="p-4 text-xs text-zinc-500">
            No closed paper trades in this window yet.
          </div>
        ) : (
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-zinc-950 text-zinc-500">
              <tr className="text-left">
                <th className="px-3 py-2">#</th>
                <th className="px-3 py-2">Strategy</th>
                <th className="px-3 py-2">Trades</th>
                <th className="px-3 py-2">Win%</th>
                <th className="px-3 py-2">PF</th>
                <th className="px-3 py-2">Sharpe</th>
                <th className="px-3 py-2">MaxDD%</th>
                <th className="px-3 py-2">Expectancy</th>
                <th className="px-3 py-2">Composite</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr
                  key={r.strategyId}
                  className={
                    "border-t border-zinc-900 hover:bg-zinc-900/40 " +
                    (r.isPrimary ? "bg-accent/5" : "")
                  }
                >
                  <td className="px-3 py-2 font-mono">{r.rank}</td>
                  <td className="px-3 py-2 font-mono text-zinc-200">
                    {r.strategyId}
                    {r.isPrimary && (
                      <span className="ml-2 rounded bg-accent/20 px-1.5 py-0.5 text-[10px] text-accent">
                        PRIMARY
                      </span>
                    )}
                  </td>
                  <td className="px-3 py-2">{r.tradesTotal}</td>
                  <td className="px-3 py-2">
                    {(r.winRate * 100).toFixed(1)}
                  </td>
                  <td className="px-3 py-2">{r.profitFactor.toFixed(2)}</td>
                  <td className="px-3 py-2">{r.sharpe.toFixed(2)}</td>
                  <td className="px-3 py-2">
                    {r.maxDrawdownPct.toFixed(1)}
                  </td>
                  <td className="px-3 py-2">{r.expectancy.toFixed(2)}</td>
                  <td className="px-3 py-2 font-mono text-accent">
                    {r.compositeScore.toFixed(1)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
